import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import {
  ProjectItem,
  TitleSection,
  ProjectName,
  Div,
  DivLeftSection,
  DivRightSection,
  Title,
  Text,
  MiddleDiv,
  Point,
  ProgressStatus,
  SmallDiv,
  MoreOptionSection,
  AssignGroup1,
  Icon
} from '../styles';
import Avatar from '../../../../component/avatar';
import SVGIcon from '../../../../assets/images/svg/SVGIcon';
import ProjectIconAvatar from '../../../../component/projectIconAvatar';
import {
  AVATAR_BORDER,
  ICON_COLORS,
  ICON_SIZE,
  PROJECT_ICON_TYPE,
  PROJECT_STATUS,
  PROJECT_STATUS_COLOR
} from '../../../../global/constants';
import { isEmpty } from '../../../../helpers/common';
import { ProjectListItemProps } from '../../../../interfaces/ProjectInterface';

const ProjectListItemComponent: React.FC<ProjectListItemProps> = ({
  item,
  isMobile,
  onClickProjectList,
  onClickFavorite,
  renderMenuDropdown
}) => {
  const handleRowClick = useCallback(() => {
    onClickProjectList(item);
  }, [onClickProjectList, item]);

  return (
    <ProjectItem role='button' onClick={handleRowClick}>
      <TitleSection>
        <ProjectIconAvatar
          size={isMobile ? 36 : 26}
          type={item?.icon?.type ?? PROJECT_ICON_TYPE.DEFAULT}
          reference={item?.icon?.reference || ''}
          backgroundColor={ICON_COLORS[item?.icon?.color || 1]}
          projectName={item?.name}
          iconSize={isMobile ? 20 : 16}
          borderRadius={isMobile ? '8px' : '6px'}
        />
        <ProjectName>
          <Div>
            <DivLeftSection>
              <Title>{item?.name}</Title>
              {!isEmpty(item?.customer?.companyName) && <Text>for {item?.customer?.companyName}</Text>}
            </DivLeftSection>
            <DivRightSection>
              <Icon
                role='button'
                className='favorite-icon'
                onClick={(e: React.SyntheticEvent) => {
                  onClickFavorite(e, item, !item?.isFavorite);
                }}>
                {item?.isFavorite ? (
                  <SVGIcon
                    name='fill-star-icon'
                    width={ICON_SIZE.MD}
                    height={ICON_SIZE.MD}
                    viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                  />
                ) : (
                  <SVGIcon
                    name='star-icon'
                    width={ICON_SIZE.MD}
                    height={ICON_SIZE.MD}
                    viewBox={`0 0 ${ICON_SIZE.LG} ${ICON_SIZE.LG}`}
                    fill='var(--text-secondary)'
                    className='star-icon'
                  />
                )}
              </Icon>
              {isMobile && renderMenuDropdown && renderMenuDropdown(item)}
            </DivRightSection>
          </Div>
        </ProjectName>
      </TitleSection>
      <MiddleDiv>
        <Point>
          <ProgressStatus>
            <SmallDiv color={PROJECT_STATUS_COLOR[item?.progressData?.status || PROJECT_STATUS.NOT_STARTED]} />
            {item?.progressData?.statusText || 'Not Started yet'}{' '}
            {item?.progressData?.status !== PROJECT_STATUS.NOT_STARTED && `(${item?.progressData?.progress || 0}%)`}
          </ProgressStatus>
        </Point>
        <MoreOptionSection>
          <AssignGroup1>
            <ul>
              {item?.users?.map((user, index) => {
                if (index > 3) return <React.Fragment key={user?.id}></React.Fragment>;
                return (
                  <li key={user?.id}>
                    <Avatar
                      imgSrc={user?.profile_photo || ''}
                      name={user?.name ? user.name : 'U N'}
                      size={20}
                      borderVariant={AVATAR_BORDER.THIN}
                      className='avatar'
                    />
                  </li>
                );
              })}
              {item?.users?.length > 4 && <li className='plus-icon'>+{item?.users?.length - 4}</li>}
            </ul>
          </AssignGroup1>
          {!isMobile && renderMenuDropdown && renderMenuDropdown(item)}
        </MoreOptionSection>
      </MiddleDiv>
    </ProjectItem>
  );
};

const ProjectListItem = observer(ProjectListItemComponent);

export default React.memo(ProjectListItem);
